/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Outlook_Ingest_Attachments_ErrorInputs */

const es_tools_outlook_ingest_attachments_error = /** @type {(inputs: Tools_Outlook_Ingest_Attachments_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al ingestar adjuntos de Outlook`)
};

const en_tools_outlook_ingest_attachments_error = /** @type {(inputs: Tools_Outlook_Ingest_Attachments_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error ingesting Outlook attachments`)
};

/**
* | output |
* | --- |
* | "Error ingesting Outlook attachments" |
*
* @param {Tools_Outlook_Ingest_Attachments_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_outlook_ingest_attachments_error = /** @type {((inputs?: Tools_Outlook_Ingest_Attachments_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Outlook_Ingest_Attachments_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_outlook_ingest_attachments_error(inputs)
	return en_tools_outlook_ingest_attachments_error(inputs)
});
export { tools_outlook_ingest_attachments_error as "tools.outlook.ingest_attachments_error" }